import React, { Component, ErrorInfo } from 'react';
import ErrorComponent from '../Error/Error';
import { EventSystemContext } from '../EventProvider/EventProvider';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error?: Error;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  static contextType = EventSystemContext;

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  state: ErrorBoundaryState = {};
  // set the types for error  and info
  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught an error', error, info);
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return <ErrorComponent error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
